export default __webpack_public_path__ + "static/climate-environmental-justice-accomplishment-2-d47acb1412209c6f91afde9f3a433818.webp";